export default {
    person: {
        wzTZ: 'Annuncio di di gestione del backstage di King Honor',
        wzKF: 'Informazioni di contatto dello sviluppatore',
        QQ1: 'QQ numero 1',
        QQ2: 'QQ numero 2',
        mailbox: 'cassetta postale',
        browser: 'Browser',
        RecommendedUse: 'Consigli d\'uso',
        mattersNeedingAttention: 'Note',
        mattersNeedingAttention1: 'È vietato modificare l\'originale e utilizzarlo per scopi commerciali',
        mattersNeedingAttention2: 'Questa pagina è destinata solo agli sviluppatori per comunicare e imparare',
        version: 'numero di versione',
    },
    home:{
        wzry:"accesso",
        game:'accesso',
        account:'Inserisci il numero di conto',
        password:'Inserisci una password',
        remember:'Ricorda la password'
    },
    Login:{
        name:"Benvenuto",
        register:"iscriversi",
        logon:"accesso",
        ZY:"Il colore autunnale è leggermente fresco e scuro",
        ReSelect:"Riselezionare"
    }
};